import { createUseStyles, Styles } from '@pff-consumer/web-ui/styles'
import { ButtonProps } from './button.props'

interface ButtonStyles {
  button: Styles
  buttonDisabled: Styles
  buttonLogo: Styles
  buttonText: Styles
  spinnerContainer: Styles
}

export const useStyles = createUseStyles<ButtonStyles, ButtonProps>((theme) => {
  return {
    button: (props) => {
      const baseStyles = {
        backgroundColor: theme.colors.webButtonBackground,
        borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
        color: theme.colors.webInverseTextColor,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
        padding: props.size === 'lg' ? theme.calcUnit(theme.spacing.s5) : theme.calcUnit(theme.spacing.s4),
        width: '100%',
        position: 'relative',
      }

      switch (props.variant) {
        case 'SocialMedia': {
          return {
            ...baseStyles,
            backgroundColor: theme.colors.webBrightBackground,
            border: `${theme.calcUnit(1)} solid ${theme.colors.webButtonBackground}`,
            padding: theme.calcUnit(theme.spacing.s4),
          }
        }
        case 'Remove': {
          return {
            ...baseStyles,
            backgroundColor: theme.colors.webErrorColor,
          }
        }
        case 'Cancel': {
          return {
            backgroundColor: theme.colors.webBrightBackground,
            color: theme.colors.webHeadingText,
            borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
            border: `${theme.calcUnit(1)} solid ${theme.colors.webButtonBorder}`,
          }
        }
        case 'Submit': {
          return {
            ...baseStyles,
            color: theme.colors.webInverseTextColor,
          }
        }
        default: {
          return baseStyles
        }
      }
    },

    spinnerContainer: ({ size }) => {
      if (size === 'sm') {
        return {
          position: 'absolute',
          left: '10%',
        }
      }
      return {}
    },
    buttonDisabled: {
      cursor: 'auto !important',
      opacity: '0.5 !important',
    },
    buttonLogo: {
      marginRight: theme.calcUnit(theme.spacing.s2),
    },
    buttonText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: theme.calcUnit(theme.spacing.s4),
      lineHeight: theme.calcUnit(19),
      textTransform: 'uppercase',
    },
  }
})
